import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import Container from '../Shared/Container';
import InnerContainer from '../Shared/InnerContainer';
import SectionHeader from '../Shared/SectionHeader';

import plnu from './plnu.jpg';
import uci from './uci.jpg';
import mbari from './mbari.jpg';
import roosevelt from './roosevelt.jpg';

var marked = require('marked');

const Affiliations_Section = (props) => (
  <Container small>
    {/* <InnerContainer> */}
      <FlexRow>
        <LogoContainer>
        <LogoLink href="https://www.pointloma.edu/"
           target="_blank">
           <Logo src={plnu} />
        </LogoLink>
        <LogoLink href="https://uci.edu/"
           target="_blank">
           <Logo src={uci} />
        </LogoLink>
        <LogoLink href="https://www.mbari.org/"
           target="_blank">
           <Logo src={mbari} />
        </LogoLink>
        <LogoLink href="https://www.roosevelt.edu/"
           target="_blank">
           <Logo src={roosevelt} />
        </LogoLink>
        </LogoContainer>
      </FlexRow>
    {/* </InnerContainer> */}
  </Container>
);

export default Affiliations_Section;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: center;

`;

const LogoContainer = styled.div`
  display: flex;
  flex:0 1 960px;
  flex-direction: row;
  justify-content: space-around;
  padding: 10px;
`;

const LogoLink = styled.a`
  text-decoration: none;
  margin: 0;
  padding: 0;

`

const Logo = styled.img`
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  ${'' /* margin: 0px 20px; */}
  max-width: 200px;
  filter:grayscale(100);
  transition: 0.3s;
  &:hover {
    filter:grayscale(0);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Affiliations_Section/index.js